import type { AvatarWithLineProps } from '../types';

export const AvatarWithLine = ({
	avatar,
	name,
	hasReplies,
	isHidden,
}: AvatarWithLineProps) => (
	<div className="relative">
		<div className="w-[32px] h-[32px] rounded-full shrink-0">
			<img
				src={avatar ?? '/images/user.png'}
				alt={name}
				className="w-full h-full rounded-full object-cover"
			/>
		</div>
		{hasReplies && !isHidden && (
			<div
				className="absolute left-1/2 top-[32px] w-[0.5px] bg-[#AAAAAA]"
				style={{
					height: 'calc(100% - 40px)',
					transform: 'translateX(-50%)',
				}}
			/>
		)}
	</div>
);
